import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { CoverImage } from 'javascripts/components/cover_image';

import styles from 'stylesheets/components/bundles/bundle_covers';

export function BundleCovers({ covers }) {
  function renderCovers() {
    return covers.map((cover, index) => {
      return (
        <div className={styles.coverImage} key={`audiobook-${index}`}>
          <CoverImage
            coverUrl={cover.coverUrl}
            bookAuthor={cover.displayAuthors}
            bookTitle={cover.displayTitle}
            defer={false}
            size='medium'
          />
        </div>
      );
    });
  }

  function getCoverClass() {
    switch (covers.length) {
      case 2:
        return styles.twoCovers;
      case 3:
        return styles.threeCovers;
      case 4:
        return styles.fourCovers;
      case 5:
        return styles.fiveCovers;
      default:
        return null;
    }
  }

  return (
    <div className={classNames(getCoverClass(), styles.bundleCovers)} data-testid='bundle-covers'>
      {renderCovers()}
    </div>
  );
}

BundleCovers.propTypes = {
  covers: PropTypes.arrayOf(
    PropTypes.shape({
      coverUrl: PropTypes.string,
      displayAuthors: PropTypes.string,
      displayTitle: PropTypes.string,
    }),
  ),
};
